import PropTypes from 'prop-types';
import PropsType from 'props-type';

const propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

const defaultProps = {
  backgroundColor: 'white',
  color: '#DEDEDE',
  height: 54,
  width: 54,
};

type ExclamationMarkIconProps = PropsType<typeof propTypes, typeof defaultProps>;

function ExclamationMarkIcon({ backgroundColor, color, height, width }: ExclamationMarkIconProps) {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 54 54"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M53 27C53 41.3594 41.3594 53 27 53C12.6406 53 1 41.3594 1 27C1 12.6406 12.6406 1 27 1C41.3594 1 53 12.6406 53 27Z"
        fill={backgroundColor}
        stroke={color}
        strokeWidth="2"
      />
      <path
        clipRule="evenodd"
        d="M28.864 19.2256L28.2256 30.4432H25.3072L24.6688 19.2256L24.5168 15H29.016L28.864 19.2256ZM29.5632 35.6112C29.5632 37.2528 28.3472 38.5296 26.7664 38.5296C25.1856 38.5296 24 37.2528 24 35.6112C24 33.9696 25.1856 32.6928 26.7664 32.6928C28.3472 32.6928 29.5632 33.9696 29.5632 35.6112Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
}

ExclamationMarkIcon.propTypes = propTypes;
ExclamationMarkIcon.defaultProps = defaultProps;

export default ExclamationMarkIcon;
